import React from 'react';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import convertTimeZone from 'utils/time';
import { useSelector } from 'react-redux';
import { selectors as profileSelectors } from 'lib/entities/profile';
import Image from 'global/Image';
import auth from 'utils/auth';
import { LabelVerifiedAccount } from 'global/Labels';
import If from 'global/ErrorHandlers/If';
import { useRouter } from 'next/router';
import { removeFormat } from 'features/chat/utils';
import LastMessagePreview from 'features/chat/LeftSidebar/ChatRooms/LastMessagePreview';
import { ChatRoomType } from 'features/chat/types';
import LabelBroadcast from 'global/Labels/LabelBroadcast';
import { SOURCE_CHAT_ROOM_VIEWED } from 'features/chat/constant';
import { DATA_CY_NAME_MESSAGE_ITEM_INBOX_CHAT } from './__tests__/constant';
import {
  MessageItemBody,
  MessageItemContent,
  MessageListContainer,
  RoomItemStatus,
  UnreadMessage,
} from './styled';
import MessageItemAvatar from './MessageItemAvatar';

export interface ItemProps {
  id?: string | number;
  attributes: any;
  info: any;
  type: ChatRoomType;
  unread_count?: number;
  status: any;
  last_message: any;
}

export interface MessageProps {
  item: ItemProps;
  onClick: any;
}

const MessageItem = ({ item, onClick }: MessageProps) => {
  // @ts-ignore
  const { username } = auth.getUserAccess();
  const router = useRouter();
  const { data: dataProfile } = useSelector(profileSelectors);
  const {
    id,
    attributes,
    info: { name, shortened_name: shortName, avatar_url: avatarUrl },
    type,
    status: { is_muted: isMuted, is_mentioned: isMentioned },
    last_message: lastMessage,
    unread_count: unreadCount,
  } = item;

  const showSenderUsername =
    type === 'ROOM_TYPE_GROUP' &&
    username !== lastMessage?.sender_username &&
    lastMessage?.sender_username !== '';
  const isDeactivated = attributes?.personal?.is_deactivated;
  const isVerified = attributes?.personal?.is_verified;
  const verifiedStatus = attributes?.personal?.verified_status;

  const onClickChat = () => {
    onClick();
    let chatUrl = '';

    switch (type) {
      case 'ROOM_TYPE_BROADCAST':
        chatUrl = 'broadcast-chat';
        break;
      case 'ROOM_TYPE_GROUP':
        chatUrl = 'group-chat';
        break;
      case 'ROOM_TYPE_PERSONAL':
        chatUrl = 'chat';
        break;
    }

    router.push(
      `/${chatUrl}/${id}?source=${SOURCE_CHAT_ROOM_VIEWED.findIndex(
        (x) => x === 'Inbox Chat',
      )}`,
    );
  };

  const asteriskRemoved = removeFormat(lastMessage);
  const isBroadcast = type === 'ROOM_TYPE_BROADCAST';

  return (
    <MessageListContainer
      onClick={onClickChat}
      data-cy={DATA_CY_NAME_MESSAGE_ITEM_INBOX_CHAT}
    >
      <MessageItemAvatar
        isDeactive={isDeactivated}
        name={name}
        src={avatarUrl}
        shortName={shortName}
        type={type}
      />
      <MessageItemBody>
        {/* @ts-expect-error */}
        <Flex align="center" justify="space-between" mb="2px">
          <Flex align="center" width="calc(100% - 100px)">
            <Text family="bold" ellipsis>
              {isDeactivated ? 'Stockbit User' : name}
            </Text>
            {/* Mock Data Only */}
            <LabelVerifiedAccount
              deprecatedVerifiedStatus={isVerified}
              verifiedStatus={verifiedStatus}
            />
            {isBroadcast && (
              // @ts-expect-error
              <Flex ml="4px">
                <LabelBroadcast />
              </Flex>
            )}
          </Flex>
          {/* @ts-expect-error */}
          <Text size="11px" color={color.midgray} elipsis>
            {convertTimeZone(lastMessage.created_at, dataProfile.country)}
          </Text>
        </Flex>
        <MessageItemContent>
          <LastMessagePreview
            message={asteriskRemoved}
            showSenderUsername={showSenderUsername}
          />
          <RoomItemStatus>
            <If condition={isMuted}>
              <Image
                src="/icon/muted-grey.svg"
                width="16"
                height="17"
                alt="mentioned"
              />
            </If>
            <If condition={isMentioned}>
              <Image
                src="/icon/mention-green.svg"
                width="16"
                height="17"
                alt="mentioned"
              />
            </If>
            <If condition={unreadCount > 0 && !isMuted}>
              <UnreadMessage>
                {unreadCount > 99 ? '99+' : unreadCount}
              </UnreadMessage>
            </If>
          </RoomItemStatus>
        </MessageItemContent>
      </MessageItemBody>
    </MessageListContainer>
  );
};

export default MessageItem;
